import type { AdminArtist, AdminArtistResponse } from '../types';

export function mapAdminArtist(data: AdminArtistResponse): AdminArtist {
  return {
    id: data.id,
    name: data.name,
    handle: data.handle,
    profileImageUrl: data.profile_image_url,
    isApproved: data.is_approved,
    destroyed: data.destroyed,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
  };
}
